import Reveal from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/config/clinicConfig";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-sand pt-10 pb-24 lg:pt-14 lg:pb-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-medium leading-snug tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
            {FAQ.heading}
          </h2>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-cocoa">
            Everything clients usually ask before their first session. Something else on your mind? Ask it in
            your free photo consultation.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="rounded-3xl border border-espresso/10 bg-cream/80 px-6">
            {FAQ.items.map((item, i) => (
              <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-espresso/10 last:border-0">
                <AccordionTrigger
                  data-testid={`faq-accordion-item-${i + 1}`}
                  className="py-5 text-left font-display text-base font-semibold tracking-tight text-espresso hover:text-clay hover:no-underline sm:text-lg [&>svg]:text-clay"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-cocoa sm:text-[15px]">
                  {item.a.split("\n\n").map((p, j) => (
                    <p key={j} className={j > 0 ? "mt-3" : ""}>
                      {p}
                    </p>
                  ))}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
